export default __webpack_public_path__ + "static/media/es-c.36669e13.jpg";